/**
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 *
 * THIS FILE IS MANAGED CENTRALLY BY THE `common-code` REPO.
 * IT COULD BE AUTO-REPLACED AT ANY TIME.
 * DO NOT MAKE CUSTOM CHANGES TO THIS FILE.
 * @see https://gitlab.com/dea-aero/development/common-code
 *
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 */
import {Button} from '@mui/material';
import {useEffect, useState} from 'react';
import CircularProgress from '@mui/material/CircularProgress';

import {useApiCallback, useApiStore} from "./util/Api";
import {useInterval} from "./util/useInterval";
import {useLoginStore} from "./useLoginStore";


export function LoginState() {

    const [loginState, setLoginState] = useState({})
    const [identity, setIdentity] = useState({})
    const asUser = useApiStore(state => state.asUser);
    const userid = useLoginStore(state => state.id);
    const setId = useLoginStore(state => state.setId);
    const user = useLoginStore(state => state.user);
    const setUser = useLoginStore(state => state.setUser);
    const image = useLoginStore(state => state.image);
    const setImage = useLoginStore(state => state.setImage);
    const permissions = useLoginStore(state => state.permissions);
    const setPermissions = useLoginStore(state => state.setPermissions);
    const setLoginUserData = useLoginStore(state => state.setLoginUserData);
    const setGroups = useLoginStore(state => state.setGroups);

    const loginStateCheck = useApiCallback('GET', '/api/check_login_state', {onDone: setLoginState, ignoreErrors: true})
    useEffect(loginStateCheck, [loginStateCheck])

    const getIdentity = useApiCallback('GET', '/api/login', {onDone: setIdentity})
    useEffect(getIdentity, [getIdentity, user])

    useEffect(() => {
        if (!loginState?.is_logged_in) {
            setUser(null)
        }
    }, [loginState, setUser]);

    useEffect(() => {
        if (user && userid && loginState?.as !== userid) {
            console.warn('loginstate changed, refetching user identity', userid, loginState.as)
            getIdentity()
        }
    }, [loginState, user, getIdentity, userid, asUser]);

    useEffect(() => {
        console.log('identity', identity)
        if (identity.hasOwnProperty('email')) {
            setId(identity.email)
        }
        if (identity.hasOwnProperty('name')) {
            setUser(identity.name)
        }
        if (identity.hasOwnProperty('image')) {
            setImage(identity.image)
        }
        if (identity.hasOwnProperty('groups')) {
            setGroups(identity.groups)
        }
        if (identity.hasOwnProperty('permissions')) {
            setPermissions(identity.permissions)
        }
        setLoginUserData(identity)
    }, [user, setId, image, permissions, setUser, setImage, setPermissions, identity, setLoginUserData, setGroups])

    useInterval(loginStateCheck, 5000)

    return <></>
}


export function Login() {
    const setId = useLoginStore(state => state.setId);
    const user = useLoginStore(state => state.user);
    const setUser = useLoginStore(state => state.setUser);
    const image = useLoginStore(state => state.image);
    const setImage = useLoginStore(state => state.setImage);
    const loading = useLoginStore(state => state.loading);
    const setLoading = useLoginStore(state => state.setLoading);
    const permissions = useLoginStore(state => state.permissions);
    const setPermissions = useLoginStore(state => state.setPermissions);
    const setLoginUserData = useLoginStore(state => state.setLoginUserData);
    const setGroups = useLoginStore(state => state.setGroups);
    const loginCode = useLoginStore(state => state.loginCode);
    const setLoginCode = useLoginStore(state => state.setLoginCode);

    const [loginUrl, setLoginUrl] = useState('')
    const [loginWindow, setLoginWindow] = useState(null)
    const [userData, setUserData] = useState({})

    const code = (loginCode ? `?single_use_code=${loginCode}` : '')
    const loginCheck = useApiCallback('GET', `/api/login${code}`, {setLoading, onDone: setUserData})
    useEffect(loginCheck, [loginCode, loginCheck])

    useEffect(() => {
        if (user) return
        const interval = setInterval(() => {
            if (!loginWindow) return
            if (!loginWindow.location) return
            if (user) return
            let m = []
            try {
                console.log('loginwindow', loginWindow.location)
                m = loginWindow.location.search.match(/^\?single_use_code=(.+)$/)
            } catch (e) {
                console.log('error looking for popup location', e)
                return
            }
            if (m) {
                const _lcode = m[1]
                setLoginWindow(null)
                loginWindow.close()
                console.log('setting loginCode', _lcode)
                setLoginCode(_lcode)
            }
        }, 1000)
        return () => clearInterval(interval)
    }, [loginWindow, setLoginWindow, setLoginCode, user, loginCode])

    useEffect(() => {
        if (userData.hasOwnProperty('redirect') && loginUrl !== userData.redirect) {
            setLoginUrl(userData.redirect)
        }
    }, [userData, setLoginUrl, loginUrl])

    useEffect(() => {
        console.log('userData', userData)
        if (userData.hasOwnProperty('email')) {
            setId(userData.email)
        }
        if (userData.hasOwnProperty('name')) {
            setUser(userData.name)
        }
        if (userData.hasOwnProperty('image')) {
            setImage(userData.image)
        }
        if (userData.hasOwnProperty('groups')) {
            setGroups(userData.groups)
        }
        if (userData.hasOwnProperty('permissions')) {
            setPermissions(userData.permissions)
        }
        setLoginUserData(userData)
    }, [user, setId, image, permissions, setUser, setImage, setPermissions, userData, setLoginUserData, setGroups])

    try {
        if (window.location.search.match(/^\?code=(.+)$/)) {
            // this is the popup login window
            return <div style={{position: 'fixed', top:0, left:0, right:0, bottom:0, backgroundColor:'#333', padding:20}}>
                Processing authentication...
            </div>
        }
    } catch(e) {}

    const promptUserToSignIn = () => {
        const w = window.open(
            loginUrl,
            '__blank',
            'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=500,height=600'
        )
        setLoginWindow(w)
    }

    return <Button
        disabled={loading || !loginUrl}
        startIcon={loading ? <CircularProgress size="1rem" /> : null}
        onClick={promptUserToSignIn}
    >
        Google SSO
    </Button>

}

export function LogoutProvider({children}) {
    const setUser = useLoginStore(state => state.setUser);
    const user = useLoginStore(state => state.user);

    const onDone = () => setUser(null)

    const logoutClick = useApiCallback('GET', `/api/logout`, {onDone})

    return user ? <span onClick={() => logoutClick()}>{children}</span> : <></>
}
